<template>
    <div class="invoice-editor p-4 bg-light rounded">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Édition de la facture</h4>
        <button class="btn btn-success btn-sm" @click="save">
          <i class="fas fa-save mr-1"></i> Enregistrer
        </button>
      </div>
  
      <div class="row mb-3">
        <div class="col-md-6">
          <label class="col-form-label">Type de facture</label>
          <select v-model="localInvoice.type" class="form-control">
            <option value="definitive">Définitive</option>
            <option value="proforma">Proforma</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="col-form-label">Date de facturation</label>
          <input type="date" class="form-control" v-model="localInvoice.issued_at" />
        </div>
      </div>
  
      <h5 class="mt-4">Articles</h5>
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Désignation</th>
            <th>Quantité</th>
            <th>Prix unitaire</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in localInvoice.items" :key="index">
            <td><input class="form-control" v-model="item.title" /></td>
            <td><input class="form-control" type="number" v-model.number="item.qty" /></td>
            <td><input class="form-control" type="number" v-model.number="item.price" /></td>
            <td>
              <button class="btn btn-danger btn-sm" @click="removeItem(index)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-outline-primary btn-sm" @click="addItem">
        <i class="fas fa-plus mr-1"></i> Ajouter un article
      </button>
  
      <h5 class="mt-4">Descriptions par section</h5>
      <div v-for="(desc, index) in localInvoice.description" :key="index" class="mb-2">
        <input class="form-control mb-1" v-model="desc.title" placeholder="Titre de section" />
        <textarea class="form-control" rows="2" v-model="desc.content" placeholder="Contenu..."></textarea>
        <button class="btn btn-danger btn-sm mt-1" @click="removeSection(index)">
          <i class="fas fa-trash"></i> Supprimer
        </button>
      </div>
      <button class="btn btn-outline-primary btn-sm" @click="addSection">
        <i class="fas fa-plus mr-1"></i> Ajouter une section
      </button>
  
      <h5 class="mt-4">Options fiscales</h5>
      <div class="form-check">
        <label class="form-check-label">
          <input class="form-check-input" type="checkbox" v-model="localOptions.useTVA" />
          Appliquer TVA ({{ localInvoice.taxes.tva }}%)
        </label>
      </div>
      <div class="form-check">
        <label class="form-check-label">
          <input class="form-check-input" type="checkbox" v-model="localOptions.useTPS" />
          Appliquer TPS ({{ localInvoice.taxes.tps }}%)
        </label>
      </div>
      <div class="form-check">
        <label class="form-check-label">
          <input class="form-check-input" type="checkbox" v-model="localOptions.useCSS" />
          Appliquer CSS ({{ localInvoice.taxes.css }}%)
        </label>
      </div>
  
      <div class="text-right mt-4">
        <p><strong>Sous-total :</strong> {{ formatCurrency(subtotal) }}</p>
        <p v-if="localOptions.useTVA"><strong>TVA ({{ localInvoice.taxes.tva }}%) :</strong> {{ formatCurrency(tva) }}</p>
        <p v-if="localOptions.useTPS"><strong>TPS ({{ localInvoice.taxes.tps }}%) :</strong> {{ formatCurrency(tps) }}</p>
        <p v-if="localOptions.useCSS"><strong>CSS ({{ localInvoice.taxes.css }}%) :</strong> {{ formatCurrency(css) }}</p>
        <h5 class="font-weight-bold">Total : {{ formatCurrency(total) }}</h5>
      </div>
    </div>
  </template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'InvoiceEditor',
  props: {
    invoice: {
      type: Object as PropType<any>,
      required: true
    },
    options: {
      type: Object as PropType<any>,
      required: true
    }
  },
  data() {
    return {
      localInvoice: JSON.parse(JSON.stringify(this.invoice)),
      localOptions: JSON.parse(JSON.stringify(this.options))
    };
  },
  computed: {
    subtotal(): number {
      return this.localInvoice.items.reduce((acc: number, item: any) => acc + item.qty * item.price, 0);
    },
    tva(): number {
      return this.localOptions.useTVA ? this.subtotal * (this.localInvoice.taxes.tva / 100) : 0;
    },
    tps(): number {
      return this.localOptions.useTPS ? this.subtotal * (this.localInvoice.taxes.tps / 100) : 0;
    },
    css(): number {
      return this.localOptions.useCSS ? this.subtotal * (this.localInvoice.taxes.css / 100) : 0;
    },
    total(): number {
      return this.subtotal + this.tva + this.tps + this.css;
    }
  },
  methods: {
    formatCurrency(amount: number): string {
      return new Intl.NumberFormat(this.localOptions.locale || 'fr', {
        style: 'currency',
        currency: this.localOptions.currency || 'XAF'
      }).format(amount);
    },
    addItem() {
      this.localInvoice.items.push({ title: '', qty: 1, price: 0 });
    },
    removeItem(index: number) {
      this.localInvoice.items.splice(index, 1);
    },
    addSection() {
      this.localInvoice.description.push({ title: '', content: '' });
    },
    removeSection(index: number) {
      this.localInvoice.description.splice(index, 1);
    },
    save() {
      console.log('this.localInvoice', this.localInvoice)
      console.log('this.localOptions', this.localOptions)
      this.$emit('save', {
        invoice: this.localInvoice,
        options: this.localOptions
      });
    }
  }
});
</script>
  
  <style scoped>
  .invoice-editor {
    max-width: 900px;
    margin: auto;
    background: #fff;
    border: 1px solid #ddd;
  }
  </style>
  